import { CurrencyCode } from '@payflip/utils';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { Icon, IconName } from '../icons';
import { Input, StyledInput } from '../input';
import { CurrencySymbol } from './styled';

export const currencySymbolMap: Record<CurrencyCode, JSX.Element> = {
  EUR: <Icon name={IconName.Euro} />
};

export type CurrencyInputProps = {
  currency?: CurrencyCode;
} & ComponentPropsWithoutRef<'input'>;

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ currency = 'EUR', step = 0.01, ...props }, ref): JSX.Element => {
    return (
      <Input {...props}>
        <CurrencySymbol {...props}>
          {currencySymbolMap[currency]}
        </CurrencySymbol>
        <StyledInput
          {...props}
          onWheel={(event): void => event.currentTarget.blur()}
          ref={ref}
          type="number"
          step={step}
        />
      </Input>
    );
  }
);
